import { AbstractControl, ValidatorFn } from '@angular/forms';

export function FullNameValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = control.value?.trim().split(' ').length > 1;
    if (!isValid) {
      return { invalidFullName: true };
    }
    return null;
  };
}
